import { render } from "./HomeAssistant2.vue?vue&type=template&id=0abface6&scoped=true"
import script from "./HomeAssistant2.vue?vue&type=script&lang=js"
export * from "./HomeAssistant2.vue?vue&type=script&lang=js"

import "./HomeAssistant2.vue?vue&type=style&index=0&id=0abface6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0abface6"]])

export default __exports__